import Pedidos from '~/services/pedidos/pedidos-admin'
import Historial from '~/services/almacen/almacen'

export const state = {
    pedidos:[],
    paginate:{},
    id_pedido:null,
    productos:[],
    pedido:{},
    cliente:{},
    historial:[],
    resumen:{},
    entrega:{},
    convenio: {},
    pagoOnline: {},
}

export const getters = {
    pedidos: state => state.pedidos,
    paginate: state => state.paginate,
    id_pedido: state => state.id_pedido,
    productos: state => state.productos,
    pedido: state => state.pedido,
    cliente: state => state.cliente,
    historial: state => state.historial,
    resumen: state => state.resumen,
    entrega: state => state.entrega,
    convenio: state => state.convenio,
    pagoOnline: state => state.pagoOnline,

}

export const mutations = {

    set_pedidos: (state,payload) => {
        state.pedidos = payload
    },
    set_paginate: (state,payload) => {
        state.paginate = payload
    },
    set_id_pedido: (state,payload) => {
        state.id_pedido = null
        state.id_pedido = payload
    },
    set_productos: (state,payload) => {
        state.productos = payload
    },
    set_pedido: (state,payload) => {
        state.pedido = payload
    },
    set_cliente: (state,payload) => {
        state.cliente = payload
    },
    set_resumenes: (state,payload) => {
        state.resumen = payload.resumen
    },
    set_entrega: (state,payload) => {
        state.entrega = payload
    },
    set_convenio: (state,payload) => {
        state.convenio = payload
    },
    set_pagoOnline: (state,payload) => {
        state.pagoOnline = payload
    },
    set_historial: (state,payload) => {
        let mensajes = [
            'Has solicitado un pedido',
            'Pedido Confirmado',
            'Pedido En Alistamiento',
            'Pedido En Empacado',
            'Pedido Enviado',
            'Pedido Entregado',
            'Pedido Cancelado'

        ]
        let iconos = [
            'icon-receipt',
            'icon-ok-circled-outline',
            'icon-cart-arrow-down',
            'icon-shopping-outline',
            'icon-truck-outline',
            'icon-shopping',
            'icon-attention-outline',
        ]

        let history = []
        for (let idx in payload){
            if(idx == 6){
                if(payload[idx] !== null){
                    let estado = state.pedido.estado
                    // console.log(estado);
                    let icon = ''
                    switch (estado){
                    case 25:
                        icon = 'icon-playlist-remove'
                        break;
                    case 26:
                        icon = 'icon-account-remove-outline'
                        break;
                    case 27:
                        icon = 'icon-cancel-circled-outline'
                        break;
                    default:
                        icon ='icon-attention-outline'
                    }

                    history.push({ content:mensajes[idx], hora:payload[idx], activo: payload[idx] !== null, icon:icon })
                }
            }else{
                history.push({ content:mensajes[idx], hora:payload[idx], activo: payload[idx] !== null, icon:iconos[idx] })
            }
        }
        state.historial = history
    }
}

export const actions = {
    async listar_pedidos({commit},payload){
        const {data} = await Historial.listar_historial(payload)
        commit('set_paginate',data.pedidos)
        commit('set_pedidos',data.pedidos.data)

    },
    async pedidos_productos({commit},id){
        const {data} = await Pedidos.pedidos_productos(id)
        console.log(data);
        commit('set_productos',data.productos)
        commit('set_pedido',data.pedido)
        commit('set_cliente',data.cliente)
        commit('set_entrega',data.entrega)
        commit('set_convenio',data.convenio)
        commit('set_pagoOnline',data.pago_online)
    },
    async pedidos_historial({commit},id){
        const {data} = await Pedidos.historial_estados(id)
        commit('set_historial',data)
    },
    async pedidos_resumenes({commit},id){
        const {data} = await Pedidos.resumenes(id)
        commit('set_resumenes',data)
    },
    async set_data({commit}){
        commit('set_resumenes',{resumen:{}})
        commit('set_historial',[])
        commit('set_productos',[])
        commit('set_pedido',{})
        commit('set_cliente',{})
    },

}
